import "./divider.scss"

interface IDivider {
    marginTop?: string;
    marginBottom?: string;
}

const Divider: React.FC<IDivider> = ({marginBottom, marginTop}): JSX.Element => {
    return (
        <div className="divider" style={{marginBottom: marginBottom, marginTop: marginTop}}/>
    )
};

export default Divider;
